/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UpdateAssignmentDto
 */
export interface UpdateAssignmentDto {

    /**
     * @type {string}
     * @memberof UpdateAssignmentDto
     */
    note?: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateAssignmentDto
     */
    operator?: JoinEntityDto;

    /**
     * New start date (SQL date). Reschedules the whole plan: every session event is shifted by the same amount, keeping its time-of-day and duration. When omitted the plan is not moved.
     *
     * @type {string}
     * @memberof UpdateAssignmentDto
     */
    startAt?: string | null;

    /**
     * New end date (SQL date). When only `startAt` is sent, the end date is shifted by the same delta automatically.
     *
     * @type {string}
     * @memberof UpdateAssignmentDto
     */
    endAt?: string | null;
}
